import qs from 'qs';
import { useSelector } from 'react-redux';

import {
  getCurrentRepositoryOwnerName,
  getCurrentRepositorySlug,
} from 'src/selectors/repository-selectors';

import repoUrls from '../../urls';

export const useCommitPageUrls = (owner?: string, slug?: string) => {
  const currentRepoOwner = useSelector(getCurrentRepositoryOwnerName);
  const currentRepoSlug = useSelector(getCurrentRepositorySlug) || '';
  const repoOwner = owner || currentRepoOwner;
  const repoSlug = slug || currentRepoSlug;

  return {
    commitsPageUrl: repoUrls.ui.commits(`${repoOwner}/${repoSlug}`),
  };
};

const qsDefaultOptions = {
  addQueryPrefix: true,
  skipNulls: true,
};

type CommentUrlOptions = {
  baseUrl?: string;
  extraQueryStringParams?: object;
};

const BASE_URL = '!api/2.0/repositories';

const DEFAULT_OPTIONS: CommentUrlOptions = {
  baseUrl: BASE_URL,
  extraQueryStringParams: {},
};

export function buildCommentUrlForCommits(
  user: string,
  repoSlug: string,
  commitId: string,
  commentId: number | string = '',
  options: CommentUrlOptions = DEFAULT_OPTIONS
): string {
  const { baseUrl, extraQueryStringParams } = options;

  const query = qs.stringify(
    {
      ...extraQueryStringParams,
    },
    qsDefaultOptions
  );

  const base = baseUrl || BASE_URL;
  const url = `/${base}/${user}/${repoSlug}/commit/${commitId}/comments/${commentId}`;

  return `${url}${query}`;
}

const urls = {
  api: {
    v20: {
      orderedCommentsFetch: (
        user: string,
        repoSlug: string,
        commitId: string
      ): string => {
        return buildCommentUrlForCommits(user, repoSlug, commitId, undefined, {
          baseUrl: '/!api/2.0/repositories',
          extraQueryStringParams: {
            fields: '+values.user.account_status',
            pagelen: 100,
            sort: 'created_on',
          },
        });
      },

      commentSave: buildCommentUrlForCommits,

      commentUpdate: buildCommentUrlForCommits,

      commentDelete: buildCommentUrlForCommits,
    },
  },
};

export default urls;
